export default __webpack_public_path__ + "static/media/trash.1f379a01.svg";